module.exports = new __parcel__URL__("mining_mission_button_text_v2.713ac951.png").toString();